export const baseUrlLoveflix = "https://loveflix.fun";
